import './Report.scss';
import Component from './Report.js';
export default Component;
